const useShowNewHomepage = () => {
  const showNewHomepage = true;

  return {
    showNewHomepage,
  };
};

export default useShowNewHomepage;
